import type { FastenerBrandCode } from "./fastener-brand";

/**
 * Component materials of the client materialForce table (MICS-55), in the
 * order the material dropdowns list them. `penn_config.material_installation_forces`
 * carries a CHECK constraint with exactly these values.
 *
 * Served verbatim by `GET /v1/filter-options/installation-materials` for the
 * application form. An application whose `material_code` is not one of these
 * (the form's free-text "Other") adds no required installation force.
 */
export const INSTALLATION_MATERIALS = [
  "Aluminum",
  "Copper",
  "FR-4 Fiberglass",
  "HSLA Steel",
  "Stainless",
  "Steel",
] as const;

export type InstallationMaterial = (typeof INSTALLATION_MATERIALS)[number];

/**
 * Kilonewtons per pound-force (1 lbf = 4.4482216152605 N by definition). The
 * materialForce table is in LBS; machine ratings
 * (`products_with_key_characteristics.max_force_kn`) are in kN.
 */
export const KN_PER_LBF = 0.0044482216152605;

/**
 * The fastener brand whose catalog prefixes the materialForce table uses
 * (`fasteners5.part_name` = PREFIX-SIZE[-LENGTH]). Only application lines of
 * this brand are looked up.
 */
export const INSTALLATION_FORCE_FASTENER_BRAND: FastenerBrandCode = "PEM";
